import React, { useState, RefObject, useMemo, useEffect } from "react";
import "./index.less";
import { elementDesc } from "@/config/dataMap";
import TowerPage from "./ElementPages/Tower";
import MixerPage from "./ElementPages/Mixer";

interface ProcessComponentProps {
  input: any;
  transInput: any;
  transInputs: any[];
  taskDataList: any[];
  selectTreeButton: any;
  scrollViewRef: RefObject<HTMLDivElement>;
}

const towerResultPages = ["工艺计算结果", "水力学计算"];
const commonResultPages = ["流股工艺数据", "流股组分数据"];

const ProcessComponent = ({
  input,
  transInput,
  transInputs,
  taskDataList,
  selectTreeButton,
  scrollViewRef,
}: ProcessComponentProps) => {
  const [selectResultPage, setSelectResultPage] = useState(commonResultPages[0]);
  const [elementTabs, setElementTabs] = useState(commonResultPages);

  const InOutStreams = useMemo(() => {
    if (!input?.elements) return {};
    const res: Record<string, { in: string[], out: string[] }> = {};
    input.elements.forEach((unit: any) => {
      if (!unit.name) return;
      res[unit.name] = {
        in: unit.inputStreams?.map((s: any) => s.name) || [],
        out: unit.outputStreams?.map((s: any) => s.name) || [],
      };
    });
    return res;
  }, [input]);

  useEffect(() => {
    if (selectTreeButton.type === "DistilStrict") {
      setElementTabs(towerResultPages);
      setSelectResultPage(towerResultPages[0]);
    } else {
      setElementTabs(commonResultPages);
      setSelectResultPage(commonResultPages[0]);
    }
  }, [selectTreeButton]);

  const buildMultiTaskSource = (elemName: string) => {
    return taskDataList.map(task => {
      const { streams } = task.output;
      const io = InOutStreams[elemName] || { in: [], out: [] };
      return {
        taskId: task.taskId,
        inputStreams: io.in.map((n: string) => streams.find((s: any) => s.name === n)),
        outStreams: io.out.map((n: string) => streams.find((s: any) => s.name === n)),
      };
    });
  };

  const showElementPage = () => {
    const multi = buildMultiTaskSource(selectTreeButton.name);
    if (selectTreeButton.type === "DistilStrict") {
      return <TowerPage
        input={input}
        transInput={transInput}
        transInputs={transInputs}
        // results={taskDataList.map(t => t.output)} 
         results={taskDataList}
        selectTreeButton={selectTreeButton.name}
        scrollViewRef={scrollViewRef}
        selectResultPage={selectResultPage}
      />;
    } else {
      return <MixerPage
        transInput={transInput}
        transInputs={transInputs}
        multiResults={multi}
        selectResultPage={selectResultPage}
      />;
    }
  };

  return (
    <div className="process-component-container">
      <div className="result-header-container">
        <div className="result-header">
          <span className="device-name-text">
            {selectTreeButton.name}
          </span>
        </div>
        <div className="result-page-list">
          {elementTabs.map((item) => (
            <button
              key={item}
              className={`result-tab-btn ${item === selectResultPage ? "active" : ""}`}
              onClick={() => setSelectResultPage(item)}
            >
              <span className="result-tab-text">{item}</span>
            </button>
          ))}
        </div>
      </div>
      <div className="element-page-content">{showElementPage()}</div>
    </div>
  );
};

export default ProcessComponent;